<style scoped>
</style>

<template>
  <Row class="feed-single-page-template" type="flex" justify="center">
      <Col :xs="24" :sm="15" :md="12" :lg="10">
        <div style="min-height:20vh;background:#ddd;">
          <div style="padding:20px">
            <Card shadow>
              <img alt=" " src="@/assets/all.jpg" width="100%" />
              <p style="margin-top:10px" align="center">Address: 2nd Flr., Right Wing, Matina Town Square, Matina Davao City</p>
              <p align="center">tapangmalasakit.ph@gmail.com</p>
            </Card>
          </div>
        </div>
      </Col>
      <Col :xs="24" :sm="15" :md="12" :lg="10">
        <div style="margin-bottom:30px;min-height:30vh;background:#ddd;">
          <div>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d989.8844629177286!2d125.59691795301516!3d7.063458865078333!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x32f96d6310a77eaf%3A0x6ce43b50cf7bb650!2sTapang+at+Malasakit!5e0!3m2!1sen!2sph!4v1516185656367" width="100%" height="250px" frameborder="0" style="border:0"></iframe>
          </div>
          <!-- <div class="site-info" style="background:#424242;text-align:center;color:white;padding:10px">
            All Rights Reserved © 2018
            <br>
            Sharpen Warrior Alliance for the Philippines.
            <br>
            Like us on <a href="https://www.facebook.com/TapangMalasakitPH">FACEBOOK </a>
          </div> -->
        </div>
      </Col>
  </Row>
</template>

<script>
export default {
  name: 'ContactUsComponent'
}
</script>
